import React from 'react';
import styles from './Section1.module.scss';

const Section1 = () => {
  return (
    <div className={`${styles.container}`}>
      <div className={`${styles.contentContainer}`}>
        <div className={`${styles.voiceIcon}`} />
        <div className={`${styles.text1}`}>Welcome to</div>
        <img
          className={`${styles.arreFestImage}`}
          src={'https://asset.arredigital.co/Arr%C3%A9+Voice+Fest/images/section/arreFestIllustration.png'}
          alt="Arre Fest"
          loading="lazy"
        />
        <div className={`${styles.textContainer}`}>
          <div className={`${styles.heading}`}>Hey Creators! </div>
          <div className={`${styles.text3}`}>
            Get ready to turn up the volume on fun and rewards at the Arré Voice Fest! 
          </div>
          <div className={`${styles.text4}`}>
            With new challenges every day, you can score awesome prizes. Don't miss your chance to shine - join the
            excitement now and let your creativity roar!
          </div>
        </div>
      </div>
    </div>
  );
};

export default Section1;
